// Sayfa ana adresten yeniden yüklenirse (ör. önizleme yenilemesi) kullanıcıyı kaldığı sayfaya geri götürür
import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const KEY = 'last-path';
const initialPath = window.location.pathname;

export const RouteMemory = () => {
  const { pathname, search } = useLocation();
  const navigate = useNavigate();
  const restored = useRef(false);

  useEffect(() => {
    if (!restored.current) {
      restored.current = true;
      const saved = sessionStorage.getItem(KEY);
      if (initialPath === '/' && pathname === '/' && saved && saved !== '/') {
        navigate(saved, { replace: true });
        return;
      }
    }
    sessionStorage.setItem(KEY, pathname + search);
  }, [pathname, search, navigate]);

  return null;
};
